export function isDisabled({ plan_number, filter_object_id, search_term }) {
  return !plan_number && !filter_object_id && !search_term
}
